import { Directive, ViewContainerRef } from '@angular/core'

@Directive({
  selector: '[mp-flowplayer-renderer]'
})

export class FlowplayerRendererDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/flowplayer/renderers/flowplayer-renderer.directive.ts